var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 86,
    viewBox: "0 0 56 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7011_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.197 31.6086L34.1923 42.5755L34.1923 56.8219L15.197 45.855M34.1923 59.6712C34.822 60.0348 35.4259 60.0832 35.8712 59.806C36.3165 59.5287 36.5667 58.9484 36.5667 58.1928L36.5667 43.9463C36.5667 43.1907 36.3165 42.3215 35.8712 41.5301C35.4259 40.7386 34.822 40.0898 34.1923 39.7262L15.197 28.7593C13.8793 27.9985 12.8226 28.6564 12.8226 30.2377L12.8226 44.4841C12.8226 45.2398 13.0728 46.109 13.5181 46.9004C13.9634 47.6918 14.5673 48.3407 15.197 48.7043L10.4482 45.9626L10.4482 48.8118L38.9411 65.2622L38.9411 62.4129L34.1923 59.6712Z",
    fill: "url(#paint0_linear_7011_69)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.692383 2.40121L3.88988 0.530282C4.30757 0.283724 4.88371 0.319984 5.51746 0.68982L2.31988 2.56075C1.68613 2.19091 1.11008 2.15465 0.692383 2.40121Z",
    fill: "url(#paint1_linear_7011_69)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3899 83.8251L51.1924 85.696C51.6029 85.4567 51.8549 84.9418 51.8621 84.2167L55.0597 82.3457C55.0597 83.0709 54.8004 83.5857 54.3899 83.8251Z",
    fill: "url(#paint2_linear_7011_69)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.881 34.0369L55.0785 32.166L55.0497 82.3477L51.8594 84.2187L51.881 34.0369Z",
    fill: "url(#paint3_linear_7011_69)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32031 2.56821L5.51789 0.697266L52.7968 28.1812L49.6064 30.0521L2.32031 2.56821Z",
    fill: "url(#paint4_linear_7011_69)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6064 30.0545L52.804 28.1836C54.0715 28.916 55.0869 30.6999 55.0869 32.1648L51.8894 34.0357C51.8894 32.5709 50.8739 30.7942 49.6064 30.0545Z",
    fill: "url(#paint5_linear_7011_69)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.605 30.0542C50.8725 30.7866 51.888 32.5706 51.888 34.0354L51.8591 84.2171C51.8591 85.6819 50.8294 86.2693 49.5619 85.5369L2.28296 58.0458C1.01547 57.3133 0 55.5294 0 54.0646L0.0288348 3.88288C0.0288348 2.41804 1.05863 1.83064 2.32612 2.56306L49.605 30.0542Z",
    fill: "url(#paint6_linear_7011_69)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7011_69",
    x1: 24.6947,
    y1: 34.2428,
    x2: 14.8245,
    y2: 51.3384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9C5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7011_69",
    x1: -5.35697,
    y1: -6.97519,
    x2: 26.7309,
    y2: 24.8984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7011_69",
    x1: 53.1224,
    y1: 93.1363,
    x2: 53.1224,
    y2: 71.1998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7011_69",
    x1: 53.4653,
    y1: 113.508,
    x2: 53.4653,
    y2: 41.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7011_69",
    x1: 0.001376,
    y1: -12.3775,
    x2: 32.0966,
    y2: 19.4963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7011_69",
    x1: 52.3431,
    y1: 56.9366,
    x2: 52.3431,
    y2: 35.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7011_69",
    x1: -20.3375,
    y1: -2.54938,
    x2: 52.3372,
    y2: 69.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7011_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.9007,
    height: 34.1914,
    fill: "white",
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 10.4482 20.3203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopIllustration);
export default __webpack_public_path__ + "static/media/laptop-illustration.81b2bbc1e35f6f7f9bf228632ad09d2a.svg";
export { ForwardRef as ReactComponent };